import React from "react";
import { makeStyles } from '@material-ui/styles';

import Routes from "../../../routes.js.jsx";

import I18n from "../../../../base/i18n.js.jsx";
import HtmlContent from "../../../../base/components/html_content.js.jsx";
import Image from "../../../../base/components/image.js.jsx";
import SmartLink from "../../../../base/links/smart_link.js.jsx";

const pageStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "white",
    "& h1": {
      fontSize: "38px",
      lineHeight: "50px",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "uppercase",
      margin: "0px 44px 0px 0px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        margin: "0px 0px 8px",
      },
    },
    "& h3": {
      fontSize: "28px",
      lineHeight: "36px",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "uppercase",
      margin: "0px 0px 32px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        margin: "0px 0px 16px",
      },
    }
  },
  container: {
    padding: "50px 16px 100px",
    fontSize: "20px",
    color: theme.palette.black,
    ['@media (max-width: 768px)']: {
      padding: "24px 24px",
    },
  },
  tooltip: {
    fontSize: "14px",
    padding: "5px",
    textAlign: "center"
  },
  spacer: {
    flexGrow: "1"
  },
  projectLink: {
    color: theme.palette.grayText,
    fontSize: "14px",
    lineHeight: "16px",
    display: "block",
    textDecoration: "none",
    textTransform: "uppercase",
    "&:hover": {
      textDecoration: "underline",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "12px",
      lineHeight: "16px"
    },
  },
  summary: {
    display: "contents",
    marginBottom: "62px",
    ['@media (max-width: 768px)']: {
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "32px",
    },
  },
  imageColumn: {
    flexBasis: "292px",
    height: "255px",
    flexShrink: 0,
    marginRight: "48px",
    ['@media (max-width: 768px)']: {
      marginRight: "0px",
      marginBottom: "24px",
      flexBasis: "100%",
      height: "178px",
    },
  },
  image: {
    width: "100%",
    height: "100%",
  },
  thanksInvestmentIntent: {
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "center",
    marginBottom: "60px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
      textAlign: "left",
      marginBottom: "35px",
    },
  },
  paymentInformationDescription: {
    marginBottom: "12px",
    ['@media (max-width: 768px)']: {
      marginBottom: "16px",
    },
  },
  paymentInformationLoaderContainer: {
    maxWidth: "66%",
    margin: "0 auto 22px",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      maxWidth: "100%",
    },
  },
  paymentInformationLoaderIndicator: {
    margin: "4px 0px 23px"
  },
  paymentInformationLoaderText: {
    fontSize: "14px",
    lineHeight: "18px",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      lineHeight: "16px",
      textAlign: "left",
    },
  },
  documents: {
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "18px",
    lineHeight: "26px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  fileLink: {
    color: theme.palette.black,
    fontWeight: theme.typography.fontWeightLight,
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    }
  }
}));

const ConfirmationEmailSection = (props) => {

  const { project } = props;

  const classes = pageStyles();

  const { name, mainGalleryImage: { urls } = {} } = project;

  let src = undefined;
  let srcSet = {};

  if (urls) {
    src = urls.large;
    srcSet = {
      "2x": urls.large2x,
      "3x": urls.large3x
    }
  }

  return (
    <React.Fragment>
      <div className={classes.summary} >
        <div className={classes.imageColumn} >
          <Image className={classes.image}
            src={src}
            alt={name}
            srcSet={srcSet} />
        </div>
      </div>

      <div className={classes.thanksInvestmentIntent}>
        <HtmlContent className={classes.paymentInformationDescription} >
          {I18n.t("web.page.investment.confirmation_emailed.thank_you", { project_name: project.name })}
        </HtmlContent>
        done
        <HtmlContent className={classes.paymentInformationDescription} >
          {I18n.t("web.page.investment.confirmation_emailed.email_sent", { project_name: project.name })}
        </HtmlContent>
        <HtmlContent className={classes.paymentInformationDescription} >
          {I18n.t("web.page.investment.confirmation_emailed.check_spam")}
        </HtmlContent>

        <p>
          Sie haben noch Fragen? <a href={"https://www.xavin.eu/kontakt"} target={"_blank"}>Wir sind für Sie da!</a>
        </p>

        <p>
          <a href={"mailto:info@xavin.eu"}>Mail</a>, <a href={"tel:+4971192537862"}>Telefon</a>
        </p>

        {/* <SmartLink to={Routes.project(project)} className={classes.projectLink} >
          {I18n.t("web.page.investment.back_to_project")}
        </SmartLink> */}

      </div>
    </React.Fragment>
  );

}

export default ConfirmationEmailSection;
